import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/FreightTemplates/BillOfLading/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>
      <div className={cn('container')}>

        <div className={cn('header__heading-container')}>
          <h1 className={cn('header__heading')}>
            <span>Bill of Lading</span>{' '}
            <span>Forms and Templates</span>
          </h1>
          <p className={cn('header__heading-description')}>
            When shipping physical inventory — be it raw materials or finished products —
            you need to come to an agreement about who is responsible for any lost,
            delayed, or damaged goods. A bill of lading (BoL) can serve as the legal
            contract between carrier and recipient, and also as a receipt of inventory
            being shipped.
          </p>
        </div>

      </div>
    </section>
  );
};

export default SectionHeader;